<template>
  <div class="general-situatio today-alarm">
    <nk-box-title :icon-class="'iconfont icon-gaikuang1'" :title="'概况'">
      <!-- <div slot="title" class="logo"> -->
      <div slot="title" >
          <!-- 插槽的内容 -->
      </div>
      <div class="content dn-content-bg" >
        <div class="main-centent" >
          <div class="main-top">
            <div class="aq aq-right ">
              <div class="ico-img xqh">
                  <p class="ico-box qh "><i class="iconfont icon-anquanyunhang" ></i></p>
                  <p class="ico-zt zt">安全运行</p>
              </div>
              <p class="main-value qh zt">{{summaryData.safeDays}}<span class="small">天</span></p>
            </div>
            <div class="aq aq-right">
              <div class="ico-img xqh">
                  <p class="ico-box qh "><i class="iconfont icon-bianyaqi" ></i></p>
                  <p class="ico-zt zt">变压器台数</p>
              </div>
              <p class="main-value qh zt">{{summaryData.transformers}}<span class="small ">台</span></p>
            </div>
            <div class="aq">
              <div class="ico-img xqh">
                  <p class="ico-box qh "><i class="iconfont icon-fuzaishuai" ></i></p>
                  <p class="ico-zt zt">负载率</p>
              </div>
              <p class="main-value qh zt">{{summaryData.loadRate}}<span class="small ">%</span></p>
            </div>
          </div>
          <div class="main-bottom">
            <div class="aq aq-right">
              <div class="ico-img xqh">
                  <p class="ico-box qh"><i class="iconfont icon-zhuangjirongliang " ></i></p>
                  <p class="ico-zt zt">装机容量</p>
              </div>
              <p class="main-value qh zt">{{summaryData.capacity}}<span class="small">kVA</span></p>
            </div>
            <div class="aq aq-right">
              <div class="ico-img xqh">
                  <p class="ico-box qh"><i class="iconfont icon-shenbaoxuliang " ></i></p>
                  <p class="ico-zt zt">申报需量</p>
              </div>
              <p class="main-value qh zt">{{summaryData.maxDemand}}<span class="small">kW</span></p>
            </div>
          </div>
        </div>
      </div>
    </nk-box-title>
  </div>
</template>
<script>
import gklogo from "@/assets/images/monitoring/companyMsg.png";
import NkBoxTitle from "@/components/common/NkBoxTitle.vue";
let vm;
export default {
  components: { NkBoxTitle },
  data() {
    return {
      floorType: "",
      floorData: [
        { id: "0", value: "黄埔区政府凯通楼" },
        { id: "1", value: "白云区政府凯通楼" },
        { id: "2", value: "天河区政府凯通楼" }
      ],
      summaryData:{},
      time:60,
      interTime:null
    };
  },
  created() {
      vm=this
      vm.getData()
  },
  mounted() {
        vm.floorType = vm.floorData[0].value;
  },
  methods: {
        getData(){
            let vm = this
            vm.$api.tmp.getTransformersSummary().then(res=>{
                if(res.success){
                    res.data.safeDays=res.data.safeDays==''?'-':res.data.safeDays
                    res.data.transformers=res.data.transformers==''?'-':res.data.transformers
                    res.data.loadRate=res.data.loadRate==''?'-':res.data.loadRate
                    res.data.capacity=res.data.capacity==''?'-':res.data.capacity
                    res.data.maxDemand=res.data.maxDemand==''?'-':res.data.maxDemand
                    vm.summaryData = res.data //概况
                    if(vm.interTime){
                        clearTimeout(vm.interTime);
                    }
                    if(vm.time > 0){
                        vm.interTime = setTimeout(() => {
                            vm.getData()
                        }, vm.time * 1000);
                    }
                }else{
                    vm.$message.error(res.msg)
                }
            }).catch(error=>{
                vm.$messge.error(error.msg)
            })
        }
  },
};
</script>
<style lang="scss" scoped>
.general-situatio ::v-deep .el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 33px;
    line-height: 33px;
    outline: 0;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
}
.general-situatio {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
  .logo {
    line-height: 25px;
    display: flex;
    flex-flow: row;
    color: rgba(30, 30, 30);
    margin-left: 5px;
    .logoImg {
      margin-right: 5px;
    }
  }
  .content {
    display: flex;
    flex: 1;
    flex-flow: column;
    min-width: 410px;
    padding: 0 8px;
    box-sizing: border-box;
    color: #181818;
    .param-item {
      line-height: 50px;
      text-align: left;
      .title {
        font-size: 16px;
        color: #666;
      }
      .changeSelect{
          margin:0 5px
      }
    }
    .main-centent{
        display: flex;
        flex: 1;
        flex-flow: column;
        .main-top{
            display: flex;
            flex: 1; 
            flex-flow: row;
            padding: 10px 0;
            box-sizing: border-box;
            .aq{
                display: flex;
                flex: 1;
                flex-flow: column;
                // background: rgba(247, 249, 248);
                .ico-img{
                    display: flex;
                    flex: 2;
                    justify-content: center;
                    align-items: center;
                    flex-flow: column;
                    .ico-box{
                        margin: 0;
                        margin-top: 4px;
                        width: 60px;
                        height: 60px;
                        // background: rgba(237, 241, 242);
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        i{
                            font-size: 32px;
                            color: rgba(59, 173, 238)
                        }
                    }
                    .ico-zt{
                        margin: 0;
                        font-size:14px
                    }
                }
                .main-value{
                    margin: 0;
                    display: flex;
                    flex: 1;
                    justify-content: center;
                    background: rgba;
                    // background: rgba(232, 237, 240);
                    align-items: center;
                    font-size: 28px;
                    position: relative;
                    border-radius: 4px;
                    .small{
                        font-size: 12px;
                        padding-top: 6px;
                        box-sizing: border-box;
                        margin-left: 3px;
                    }
                }
            }
            .aq-right{
                margin-right: 8px;
            }
        }  
        .main-bottom{
            display: flex;
            flex: 1; 
            flex-flow: row;
            padding-bottom: 10px ;
            box-sizing: border-box;
            .aq{
                display: flex;
                flex: 1;
                flex-flow: column;
                // background: rgba(247, 249, 248);
                .ico-img{
                    display: flex;
                    flex: 2;
                    justify-content: center;
                    align-items: center;
                    flex-flow: column;
                    .ico-box{
                        margin: 0;
                        margin-top: 4px;
                        width: 60px;
                        height: 60px;
                        // background: rgba(237, 241, 242);
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        i{
                            font-size: 32px;
                            color: rgba(59, 173, 238)
                        }}
                    .ico-zt{
                        margin: 0;
                        font-size:14px
                    }
                }
                .main-value{
                    margin: 0;
                    display: flex;
                    flex: 1;
                    justify-content: center;
                    background: rgba;
                    // background: rgba(232, 237, 240);
                    align-items: center;
                    font-size: 28px;
                    border-radius: 4px;
                    .small{
                        font-size: 12px;
                        padding-top: 6px;
                        box-sizing: border-box;
                        margin-left: 3px;
                    }
                }
            }
            .aq-right{
                margin-right: 8px;
            }
        }  
    }
  }
}
</style>